import languages from '../languages';

const format = (value, format, lang) => {
  let lng = lang.toLowerCase();
  if (format.startsWith('date')) {
    return formatDate(value, format, lng);
  }

  if (format.startsWith('number')) {
    return formatNumber(value, format, lng);
  }

  if (format.startsWith('currency')) {
    return formatCurrency(value, lng);
  }
  return value;
};

const formatCurrency = (value, lng) => {
  const currencyCode = languages.find(item => item.id == lng).currencyCode;
  return new Intl.NumberFormat(lng, {
    style: 'currency',
    currency: currencyCode,
  }).format(value);
};

const formatDate = (value, format, lng) => {
  const options = toOptions(format, 'date');

  return options === null ? value : new Intl.DateTimeFormat(lng, options).format(value);
};

const formatNumber = (value, format, lng) => {
  const options = toOptions(format, 'number');

  return options === null ? value : new Intl.NumberFormat(lng, options).format(value);
};

const toOptions = (format, specifier) => {
  if (format.trim() === specifier) {
    return {};
  } else {
    try {
      return JSON.parse(toJsonString(format, specifier));
    } catch (error) {
      console.error(error);

      return null;
    }
  }
};

const toJsonString = (format, specifier) => {
  const inner = format
    .trim()
    .replace(specifier, '')
    .replace('(', '')
    .replace(')', '')
    .split(';')
    .map(param =>
      param
        .split(':')
        .map(name => `"${name.trim()}"`)
        .join(':')
    )
    .join(',');
  return '{' + inner + '}';
};

export default format;